import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { clubQueryKeys } from "./clubQueryKeys";

type CustomPaymentCategoryProps = {
  api: ApiType;
  clubId: number;
};

export const customPaymentCategoryQueryFn = async ({
  api,
  clubId,
}: CustomPaymentCategoryProps) =>
  (await api.clubApi.customPaymentCategory(clubId)).data;

export const useQueryCustomPaymentCategory = ({
  api,
  clubId,
}: CustomPaymentCategoryProps) => {
  return useQuery({
    queryKey: clubQueryKeys.customPaymentCategory(clubId),
    queryFn: async () => (await api.clubApi.customPaymentCategory(clubId)).data,
  });
};
